module.exports = __webpack_public_path__ + "static/media/polkadot.bf5610e9.svg";